import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalFilesComponent } from './modal-files.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { TranslateModule } from '@ngx-translate/core';
import {ImageModule} from 'primeng/image';

@NgModule({
  declarations: [
    ModalFilesComponent
  ],
  imports: [
    CommonModule,
    NgxDropzoneModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ImageModule
  ],
  exports: [
    ModalFilesComponent
  ]
})
export class ModalFilesModule { }
